/*
 * @Descripttion: 组织结构
 * @Author: chenjinsheng
 * @Date: 2021-03-26 16:24:23
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-09-22 17:07:34
 */

import $axios from '@/service/httpServer';
import $config from '@/config/index';
export const getOrganization = p => $axios.post('/upms/organization/list', p); // 获取组织结构
export const getOrganizationNew = p =>
  $axios.get('/upms/organization/getList', p); // 新版获取组织结构
export const getNewOrganizationDetail = p =>
  $axios.get('/upms/organization/showData', { parentId: p }); // 获取组织结构详情
export const getOrganizationDetail = p =>
  $axios.get('/upms/organization/details/' + p); // 获取组织结构详情
export const getOrganizationLog = p =>
  $axios.get('/upms/organization/auditLog/list', p); // 获取日志
export const delOrganization = p =>
  $axios.delete('/upms/organization/delete', p); // 删除
export const addOrganization = p => $axios.post('/upms/organization/add', p);
export const editOrganization = p => $axios.post('/upms/organization/edit', p);
export const getHistoryOrganization = p =>
  $axios.get('/upms/organization/show', p);
export const moveOrganization = p => $axios.post('/upms/organization/move', p);
export const checkOrganization = id =>
  $axios.get('/upms/organization/check', { id: id, flag: true });
export const switchOrganizationEnable = id =>
  $axios.get('/upms/organization/enable', { id: id }); // 切换禁用开启
export const getDepartmentUser = p =>
  $axios.get($config.dbaseURL + '/dwwb-portal/choose/department-user', p); // 获取部门和用户
export const queryDepartment = p =>
  $axios.get($config.dbaseURL + '/dwwb-portal/choose/department/query', p); // 获取部门
export const queryUser = p =>
  $axios.get($config.dbaseURL + '/dwwb-portal/choose/user/query', p); // 获取用户
export const queryLines = p =>
  $axios.get($config.dbaseURL + '/dwwb-portal/line/query', p); // 获取条线
